export default "__VITE_ASSET__Bsn_ONgr__"